/**
 * SourceVerificationEmpty — empty-state copy for the verification view (F6-6).
 *
 * The GET endpoint can't tell "never run" from "run, found nothing", so the
 * caller passes `noCitationsFound` (a run completed this session with zero
 * citations) to pick the right message. Viewer (no run capability) gets a
 * read-only prompt.
 */
import * as React from 'react';

export function SourceVerificationEmpty({
  canRun,
  running,
  noCitationsFound,
}: {
  canRun: boolean;
  running: boolean;
  noCitationsFound: boolean;
}): React.JSX.Element {
  let title: string;
  let body: string;

  if (running) {
    title = '正在核验…';
    body = '逐条检索来源库并判定一致性，引用较多时可能需要一些时间。';
  } else if (noCitationsFound) {
    title = '未发现可核验的法条引用';
    body = '本比对的文档内容中没有识别到规整的法条引用。';
  } else if (canRun) {
    title = '尚未发起来源核对';
    body = '点击上方「发起来源核对」，对本比对中的法条引用做存在性、现行有效性与内容一致性核验。';
  } else {
    title = '尚未核验';
    body = '本比对还没有来源核对结论。需要律师或审核员先发起核验。';
  }

  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-ink-200 bg-ink-0 px-6 py-12 text-center">
      <p className="text-sm font-semibold text-ink-700">{title}</p>
      <p className="max-w-md text-xs leading-relaxed text-ink-500">{body}</p>
    </div>
  );
}

export default SourceVerificationEmpty;
